import Svg from "../../assets/icons-sprite.svg";


type Props = {
  id: string,
  className?: string,
}

const SpriteSvg = ({id,className}:Props) => {
  return(
    <svg fill="#000" viewBox="0 0 16 16" width="16" height="16" className={`${className || ""}`}>
       <use href={`${Svg}#${id}`} />
    </svg>
  );
}

export default SpriteSvg;
